<template>
  <div class="wt2-sg wt-main-story-view">
    <div class="-top-panel">
      <wt-story-lightbox />
      <wt-story-rcp />
    </div>
    <wt-story-toolbox />
    <wt-timeline-adapter />
    <wt-version-history-panel />
  </div>
</template>

<script>
import wtStoryLightbox from './Lightbox/index.vue';
import wtStoryRcp from './wtStoryRcp.vue';
import wtStoryToolbox from './Toolbox/wtStoryToolbox.vue';
import wtTimelineAdapter from './Timeline/wtTimelineAdapter.vue';
import wtVersionHistoryPanel from './wtVersionHistoryPanel.vue';
import Vue from 'vue';
import app from 'app';

export default Vue.extend({
  name: 'wtMainStoryView',
  components: {
    wtStoryLightbox,
    wtStoryRcp,
    wtStoryToolbox,
    wtTimelineAdapter,
    wtVersionHistoryPanel,
  },

  store() {
    return app.rootStore;
  },

  data() {
    return {};
  },

  created() {},
  mounted() {
    app.timelineGateway.whenWidgetReady.then(() => {
      app.namespace.Controller.AssetController.checkIfNavigatedToAssetEditor();
    });
  },

  methods: {},
});
</script>

<style lang="scss">
.wt-main-story-view {
  $masthead-height: 50px;
  $top-panel-height: 315px;
  $toolbox-height: 50px;

  display: flex;
  flex-direction: column;

  .-top-panel {
    display: flex;
    height: $top-panel-height;

    .wt-story-lightbox {
      border-right: 1px solid #cacaca;
      flex-grow: 1;
    }
    .wt-story-rcp {
      flex-shrink: 0;
    }
  }

  .wt-story-toolbox {
    height: $toolbox-height;
    background-color: #f2f2f2;
    flex-shrink: 0;
  }

  .wt-story-timeline {
    height: calc(
      100vh - #{$masthead-height + $top-panel-height + $toolbox-height}
    );
  }
}
</style>
